<template>
  <div class="main-page report-notarization">
    <Menus
      title="办证指引"
      :border="true"
    >
      <a
        slot="left-link"
        href="javascript:void(0)"
        @click="goback"
      >
      </a>
    </Menus>
    <div class="container-flex">
      <div class="content">
        <div
          id="div_report"
          class="report-container"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
export default {
  components: {
    Menus
  },
  data () {
    return {
      report: '',
      appback: false
    }
  },
  async mounted () {
    const _this = this
    this.$loading.show()
    if (this.$route.fullPath) {
      const url = 'https://yn.12348.laway.cn/api/get' + this.$route.fullPath.replace('/guide', '')
      $.get(url, results => {// eslint-disable-line
        _this.$loading.hide()
        if (results.status === 1) {
          $("#div_report").html(results.result.content); // eslint-disable-line
          this.report = results.result.content
          this.$nextTick(() => {
            if (document.getElementById('rotue_jump')) {
              document.getElementById('rotue_jump').onclick = e => {
                const href = e.target.dataset.href
                this.$router.push(href)
              }
            }
            if (document.getElementById('gohome')) {
              document.getElementById('gohome').onclick = e => {
                this.$router.push('/')
              }
            }
            if (window.appback) {
              this.appback = window.appback
            }
          })
        }
      })
    }
  },
  methods: {
    goback () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="stylus" >
.report-notarization
  .content
    padding 0.5rem 0
    margin 0.3rem auto 0 auto
    color #333
  #div_report
    width 12rem
    margin 0 auto
    border-radius 0.3rem
    padding 0.5rem 0.3rem 0.6rem 0.3rem
    line-height 1.6
    background-color rgba(255, 255, 255, 1)
    border solid 1px rgba(255, 255, 255, 1)
    box-shadow 0 0.1rem 0.25rem rgba(0, 0, 0, 0.05)
    h2
      line-height 1.8
      margin 0.2rem 0 0.15rem 0
      font-size 0.34rem
    h3
      line-height 1.8
      margin 0.1rem 0 0.2rem 0
      font-size 0.28rem
    p
      font-size 0.22rem
      margin-bottom 0.15rem
</style>
